<template>
  <div class="modal fade show" ref="modalSuccess" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-success">
        <div class="modal-header" :class="{'full-border': fullBorder}" v-if="modalHeader">
          <div class="title" v-html="modalHeader"></div>
        </div>
        <div class="modal-body">
          <div>
            <p class="modal-txt" :class="classContent" v-html="modalContent"></p>
            <slot name="content"></slot>
          </div>
        </div>
        <div class="modal-footer pt-0">
          <router-link v-if="redirectButton" :to="{name: redirectButton, params: paramsRouter}" tag="button" class="btn btn-common w-100">{{textButtonClose}}</router-link>
          <button v-else type="button" class="btn btn-common w-100" data-dismiss="modal">{{textButtonClose}}</button>
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modalMixin from './modalMixin';

export default {
  mixins: [modalMixin],
  name: 'ModalSuccess',
  props: {
    idModal: {
      type: String,
      default: 'idModal'
    },
    modalHeader: {
      type: String,
      default: ''
    },
    modalContent: {
      type: String,
      default: ''
    },
    keyTextButtonClose: {
      type: String,
      default: 'common.button.close_modal_success'
    },
    redirectButton: {
      type: String,
      default: ''
    },
    paramsRouter: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fullBorder: {
      type: Boolean,
      default: false
    },
    classContent: {
      type: String,
      default: 'common.button.close_modal_success'
    },
    classButton: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ref: 'modalSuccess'
    }
  },
  computed: {
    textButtonClose () {
      return this.$t(this.keyTextButtonClose);
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/ModalSuccess.vue